/* ВРІТ board filled from Enote (stays without a box, «з Enote» badge, suggested discharge). Kept apart from uk.ts/en.ts to keep merges small. */
export const vritEnoteUk = {
  'vrit.cat.none': 'Без категорії',
  'vrit.fromEnote': 'з Enote',
  'vrit.fromEnoteHint': 'Пацієнт у стаціонарі за даними Enote (прапорець «Стаціонар» у закріпленні тварини)',
  'vrit.enoteSync': 'Синхронізувати з Enote',
  'vrit.enoteSyncDone': 'Enote: у стаціонарі {n}; додано {created}, пов’язано {linked}, оновлено {updated}, запропоновано виписку {suggested}',
  'vrit.enoteSyncFailed': 'Enote не відповів ({error}); дошку звірено з останніми даними.',
  'vrit.unplaced': 'Нерозміщені',
  'vrit.unplacedHint': 'Пацієнти, яких Enote показує у стаціонарі, але ще без боксу. Відкрийте картку, щоб розмістити в бокс і вказати категорію.',
  'vrit.statUnplaced': 'Нерозміщені',
  'vrit.notPlaced': 'не розміщено',
  'vrit.placeIn': 'Розмістити в бокс',
  'vrit.chooseCategory': 'Вказати категорію',
  'vrit.enoteDischarged': 'Enote: виписано',
  'vrit.enoteDied': 'Enote: летальний випадок',
  'vrit.enoteDischargeHint': 'З {at} Enote більше не показує пацієнта у стаціонарі. Запис не закрито автоматично: оформіть виписку на вкладці «Виписка» або закрийте запис.',
  'vrit.warn.no_category': 'категорію не вказано',
  'vrit.warn.no_box': 'не розміщено в бокс',
  'vrit.warn.enote_discharged': 'Enote: виписано — оформіть виписку',
  'vrit.ev.enote_sync': 'Пов’язано з Enote',
  'vrit.ev.enote_readmitted': 'Enote знову показує пацієнта у стаціонарі',
  'vrit.ev.enote_discharge': 'Enote: пацієнта виписано ({outcome})',
  'vrit.ev.admission_enote': 'Прийом у ВРІТ (з Enote)',
}

export const vritEnoteEn: Record<keyof typeof vritEnoteUk, string> = {
  'vrit.cat.none': 'No category',
  'vrit.fromEnote': 'from Enote',
  'vrit.fromEnoteHint': 'Inpatient according to Enote (the «Стационар» flag of the patient’s assignment)',
  'vrit.enoteSync': 'Sync with Enote',
  'vrit.enoteSyncDone': 'Enote: {n} inpatients; {created} added, {linked} linked, {updated} updated, {suggested} discharges suggested',
  'vrit.enoteSyncFailed': 'Enote did not respond ({error}); the board was reconciled with the latest data.',
  'vrit.unplaced': 'Not placed',
  'vrit.unplacedHint': 'Patients Enote shows as inpatients who have no box yet. Open the card to place them in a box and set the category.',
  'vrit.statUnplaced': 'Not placed',
  'vrit.notPlaced': 'not placed',
  'vrit.placeIn': 'Place in a box',
  'vrit.chooseCategory': 'Set category',
  'vrit.enoteDischarged': 'Enote: discharged',
  'vrit.enoteDied': 'Enote: died',
  'vrit.enoteDischargeHint': 'Since {at} Enote no longer shows the patient as an inpatient. The stay was not closed automatically: complete the discharge on the «Discharge» tab or close the stay.',
  'vrit.warn.no_category': 'category not set',
  'vrit.warn.no_box': 'not placed in a box',
  'vrit.warn.enote_discharged': 'Enote: discharged — complete the discharge',
  'vrit.ev.enote_sync': 'Linked to Enote',
  'vrit.ev.enote_readmitted': 'Enote shows the patient as an inpatient again',
  'vrit.ev.enote_discharge': 'Enote: patient discharged ({outcome})',
  'vrit.ev.admission_enote': 'Admitted to ВРІТ (from Enote)',
}
